<template>
    <div class="relative mt-3 xl:w-48 w-full">
        <HeadlessListbox v-model="selectedLang" v-slot="{ open }" @update:model-value="handleUpdate">
            <HeadlessListboxButton
                as="button"
                class="p-4 bg-gray-900 text-body-md text-gray-100 rounded-lg w-full flex items-center justify-between"
            >
                <p>{{ handleLangText }}</p>
                <Icon :name="open ? 'tabler:chevron-up' : 'tabler:chevron-down'" size="24px" />
            </HeadlessListboxButton>

            <transition
                leave-active-class="transition duration-100 ease-in"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <HeadlessListboxOptions
                    class="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-gray-850 p-3 shadow-lg"
                    as="ul"
                >
                    <template v-for="langItem in items" :key="langItem.title">
                        <HeadlessListboxOption
                            as="li"
                            class="cursor-pointer text-body-md py-2 text-gray-500 hover:text-gray-300 transition-all"
                            :value="langItem.value"
                        >
                            {{ langItem.title }}
                        </HeadlessListboxOption>
                    </template>
                </HeadlessListboxOptions>
            </transition>
        </HeadlessListbox>
    </div>
</template>

<script setup lang="ts">
const { locale, setLocale } = useI18n();

const selectedLang = ref();

const items = [
    { title: "English (US)", desc: "English (US)", value: "en" },
    { title: "French (FR)", desc: "French (FR)", value: "fr" },
    { title: "English (GB)", desc: "English (GB)", value: "en-gb" },
];

const handleLangText = computed(() =>
    selectedLang.value
        ? items.filter((x) => x.value === selectedLang.value)[0].title
        : items.filter((x) => x.value === locale.value)[0].title
);

const handleUpdate = (val: string) => {
    setLocale(val);
};
</script>
